import { render, staticRenderFns } from "./user-agreement.html?vue&type=template&id=427028e0&scoped=true&"
import script from "./user-agreement.js?vue&type=script&lang=js&"
export * from "./user-agreement.js?vue&type=script&lang=js&"
import style0 from "./user-agreement.scss?vue&type=style&index=0&id=427028e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427028e0",
  null
  
)

export default component.exports